import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Link, useLocation } from 'react-router-dom';
import { changePasswordRequest } from '../../Common/requests'
import { usePostHog } from '@posthog/react';
import ArrowSVG from '../../assets/icons/arrow-up.svg'
import SimpleReactValidator from "simple-react-validator";
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
    const { t } = useTranslation('marketplace');
    const posthog = usePostHog();
    const [validator] = useState(new SimpleReactValidator({
        messages: {
            in: t('auth.confirmPasswordMatch')
        }
    }));
    const [disabled, setDisabled] = useState(false);
    const [, forceUpdate] = useState();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [token, setToken] = useState('');
    const [isPassowrdReset, setIsPassowrdReset] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showCPassword, setShowCPassword] = useState(false)

    const location = useLocation()

    useLayoutEffect(() => {
        let query = new URLSearchParams(location.search);
        const id = query.get('id')
        if (id)
            setToken(id)

    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const handleLogin = async (evt) => {
        if (typeof evt !== "undefined" && evt != null) {
            evt.preventDefault();
        }
        if (!validator.allValid()) {
            validator.showMessages();
            forceUpdate(1);
            setDisabled(false);
        } else {
            let data = { token, newPassword: password };
            setDisabled(true)
            try {
                const response = await changePasswordRequest(data);
                if (response.status === 200) {
                    posthog?.capture('password_reset_completed');
                    setPassword("");
                    setConfirmPassword("");
                    setDisabled(false);
                    setIsPassowrdReset(true);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }



    return (
        token ? <div className="auth-page">
            <div className="container">
                <div className="block-content inner-head">
                    <Link className="icon" to="/login">
                        <ReactSVG src={ArrowSVG} />
                    </Link>
                </div>

                {isPassowrdReset ? <div className="block-content content-holder text-center">
                    <h4>
                        {t('auth.passwordResetSuccess')}
                        <Link className="icon" to="/login">
                            <div className="button-holder mt-3">
                                <button type="button" className="btn btn-secondary">{t('auth.login')}</button>
                            </div>
                        </Link>

                    </h4>

                </div> :
                    <div className="block-content content-holder">
                        <h2>
                            {t('auth.changePasswordTitle')}
                        </h2>
                        <p>
                            {t('auth.changePasswordSubtitle')}
                        </p>
                        <form onSubmit={handleLogin} noValidate>
                            <div className="form-group">
                                <label>{t('auth.newPassword')}</label>
                                <input type={showPassword ? "text" : "password"} className="form-control" placeholder={t('auth.newPasswordPlaceholder')} value={password} onChange={(e) => { setPassword(e.target.value) }} />
                                {validator.message(
                                    "password",
                                    password,
                                    "required|min:8",
                                    { className: "text-danger" }
                                )}
                                <span className="form-icon" onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                                </span>
                            </div>
                            <div className="form-group">
                                <label>{t('auth.confirmPasswordShort')}</label>
                                <input type={showCPassword ? "text" : "password"} className="form-control" placeholder={t('auth.confirmPasswordShort')} value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} />
                                {validator.message(
                                    "confirmPassword",
                                    confirmPassword,
                                    `required|in:${password}`,
                                    { className: "text-danger" }
                                )}
                                <span className="form-icon" onClick={() => setShowCPassword(!showCPassword)}>
                                    {showCPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                                </span>
                            </div>
                            <div className="button-holder mt-3">
                                <button type="submit" className="btn btn-secondary" disabled={disabled}>{t('auth.changePassword')}</button>
                            </div>
                        </form>
                    </div>
                }
                <h6 className="text-grey text-center"> {t('auth.copyrightNotice')}</h6>
            </div>
        </div> : <div className="auth-page">
            <div className="container">
                <div className="block-content content-holder text-center">
                    <h4>
                        {t('auth.unauthorized')}
                    </h4>

                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
